import React from "react";
import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";
import { useRegisterDepartment } from "../../../../hooks/useRegisterDepartment";
import UserFields from "../user/UserFields";
import DepartmentFields from "./DepartmentsFields";
import FormBtns from "../../../../../common/layout/form/NewFormBtns";
import { validationSchemaDepartment } from "../../../../actions/validationSchema";
import InputHeader from "../../InputHeader";
import MessageContainer from "../MessageContainer";
import ActivityIndicator from "../../../../../common/layout/ActivityIndicator";
import { useUserData } from "../../../../../common/hooks/useUserData";

export interface RegisterDepartmentProps {}

const RegisterDepartment: React.FC<RegisterDepartmentProps> = () => {
  const { t } = useTranslation("admin");
  const { cancelForm, handleSubmit, isLoading } = useRegisterDepartment();
  const { user } = useUserData();
  const requireEmail = true;
  
  return (
    <Formik
      initialValues={{
        email: requireEmail ? '' : user && user.emails[0], 
      }}
      onSubmit={handleSubmit}
      validationSchema={validationSchemaDepartment}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ handleSubmit }) => (
        <Form translate="yes" onSubmit={handleSubmit}>
          <InputHeader text={t("auth.headers.userData") as string} />
          <UserFields/>
          <InputHeader text={t("auth.headers.departmentData") as string} />
          <DepartmentFields />
          <FormBtns positionAbsolute cancelForm={cancelForm} submitBtnText={t("auth.buttons.register") as string}/>
          {isLoading ? <ActivityIndicator/> : <MessageContainer/>}
        </Form>
      )}
    </Formik>
  );
};

export default RegisterDepartment;